/**
 * 라우트 설정
 * - 메뉴 ID와 URL 경로 매핑
 * - 역할별 접근 권한 정의
 */

export interface RouteConfig {
  path: string;
  menuId: string;
  subMenuId: string;
  roles?: string[];
}

// 서브메뉴 ID → URL 경로 매핑
export const SUBMENU_ROUTES: Record<string, string> = {
  // 이용자 관리 (customers)
  'user-management': '/users',
  'customer-management': '/customers',
  'user-management-all': '/users/all',

  // 서비스 이용 (services)
  'service-usage': '/services',
  'service-management': '/service-management',
  'service-credit-plans': '/service-plans',
  'login-integrations': '/login-integrations',
  'user-activity': '/activity',

  // 설정 (settings)
  'customer-settings': '/settings',
  'activity-logs': '/logs',
  'user-logs-all': '/logs/all',
  'system-logs': '/logs/system',
  'ai-monitoring': '/ai-monitoring',
  'ai-provider-settings': '/settings/ai-providers',
  'environment-settings': '/settings/environment',
  'email-templates': '/settings/email-templates',
};

// URL 경로 → 메뉴 정보 매핑 (역방향)
export const PATH_TO_MENU: Record<string, { menuId: string; subMenuId: string }> = {
  // 이용자 관리
  '/users': { menuId: 'customers', subMenuId: 'user-management' },
  '/customers': { menuId: 'customers', subMenuId: 'customer-management' },
  '/users/all': { menuId: 'customers', subMenuId: 'user-management-all' },

  // 서비스 이용
  '/services': { menuId: 'services', subMenuId: 'service-usage' },
  '/service-management': { menuId: 'services', subMenuId: 'service-management' },
  '/service-plans': { menuId: 'services', subMenuId: 'service-credit-plans' },
  '/login-integrations': { menuId: 'services', subMenuId: 'login-integrations' },
  '/activity': { menuId: 'services', subMenuId: 'user-activity' },

  // 설정
  '/settings': { menuId: 'settings', subMenuId: 'customer-settings' },
  '/logs': { menuId: 'settings', subMenuId: 'activity-logs' },
  '/logs/all': { menuId: 'settings', subMenuId: 'user-logs-all' },
  '/logs/system': { menuId: 'settings', subMenuId: 'system-logs' },
  '/ai-monitoring': { menuId: 'settings', subMenuId: 'ai-monitoring' },
  '/settings/ai-providers': { menuId: 'settings', subMenuId: 'ai-provider-settings' },
  '/settings/environment': { menuId: 'settings', subMenuId: 'environment-settings' },
  '/settings/email-templates': { menuId: 'settings', subMenuId: 'email-templates' },

  // 워크플로우 에디터 (워크플로우 메뉴로 하이라이트)
};

// 경로에서 메뉴 정보 찾기 (동적 라우트 지원)
export const getMenuFromPath = (pathname: string): { menuId: string; subMenuId: string } | null => {
  // 정확히 일치하는 경로 먼저 확인
  if (PATH_TO_MENU[pathname]) {
    return PATH_TO_MENU[pathname];
  }

  // 동적 라우트 확인

  // 부분 일치 확인 (가장 긴 경로부터)
  const sortedPaths = Object.keys(PATH_TO_MENU).sort((a, b) => b.length - a.length);
  for (const path of sortedPaths) {
    if (pathname.startsWith(path)) {
      return PATH_TO_MENU[path];
    }
  }

  return null;
};

// 서브메뉴 ID로 URL 가져오기
export const getPathFromSubMenu = (subMenuId: string): string => {
  return SUBMENU_ROUTES[subMenuId] || '/services';
};

// 역할별 기본 페이지
export const getDefaultPathForRole = (role: string): string => {
  switch (role) {
    case 'saas_admin':
    case 'admin':
      return '/users';
    case 'user':
    default:
      return '/services';
  }
};
